export const productName = 'MEGA PACK TOPOGRAFÍA LISTO';
export const productImage = 'https://cdn.magicpatterns.com/uploads/keNtXshKEazWyXJzZCEBdJ/MOCKUP.png';

export const checkoutUrl = 'https://megapack-topografia-listo.impultienda.ar/checkout';

export const price = 'USD 19,00';
export const priceBefore = 'USD 40,00';

export const totalVolumes = 9;
export const totalBonuses = 5;
export const bonusTotalValue = 'USD 70,00';

export const included = [
  'Tomo 1 — Fundamentos de Topografía',
  'Tomo 2 — Mediciones, Errores y Cálculos',
  'Tomo 3 — Planimetría y Levantamientos',
  'Tomo 4 — Altimetría, Nivelación y Perfiles',
  'Tomo 5 — Estaciones Totales y GNSS',
  'Tomo 6 — Cartografía Digital y QGIS',
  'Tomo 7 — Drones y Fotogrametría',
  'Tomo 8 — Topografía Aplicada',
  'Tomo 9 — Planificación y Proyectos 2026',
  'Bono 1 — 150 Actividades y Prácticas',
  'Bono 2 — 60 Instrumentos de Evaluación',
  'Bono 3 — 100 Problemas Resueltos',
  'Bono 4 — Guía Visual de Instrumentos',
  'Bono 5 — 30 Proyectos Integradores',
  'Garantía de 7 días sin preguntas',
  'Pago en USD',
  'Acceso inmediato',
  'Formato PDF listo para usar',
];

export const systemNegatives = [
  'No es teoría copiada de un manual desactualizado.',
  'No es una colección de prácticas sueltas sin coherencia.',
  'No es material que tengas que adaptar entero.',
];

export const closingLines = [
  'Sin más noches buscando cómo explicar conceptos topográficos complejos',
  'Sin más clases armadas de apuro con material que no funciona',
  'Sin más alumnos desconectados que no entienden para qué sirve la topografía',
  'Sin más fines de semana perdidos construyendo material desde cero',
  'Sin más silencios incómodos frente a preguntas técnicas que te ponen en aprietos',
];
